import { Box, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import './SPQFormButton.scss';
import { useSelector } from 'react-redux';
function SPQFormButton({ ...props }) {
  const { showSuccessPopUp, disabledBttn, errorMsg } = useSelector(
    (state: any) => state.sellerProfile
  );

  const { label } = props;

  let setDisabled = disabledBttn.hasOwnProperty(props.formName)
    ? disabledBttn[props.formName]
    : true;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {errorMsg !== '' && (
        <Box className="formButtonContainer">
          <output>{errorMsg} </output>
        </Box>
      )}
      {showSuccessPopUp !== '' && (
        <Box className="successScreenReader">
          <output>{errorMsg} </output>
        </Box>
      )}
      {props.showLoading ? (
        <LoadingButton
          loading
          variant="primary"
          size="md"
          // className="spButton loading"
        >
          {' '}
          {label}
        </LoadingButton>
      ) : (
        <Button
          variant="primary"
          size="md"
          // className={`spButton ${props.compName}`}
          onClick={() => props.handleClick()}
          disabled={setDisabled}
        >
          {label}
        </Button>
      )}
    </Box>
  );
}

export default SPQFormButton;
